<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="()=>{newResource = {source:'Telephone', email:'no_email'}; dialog = true;}"
          />
        </v-col>
        <v-col cols="12" STATS>
          <leadsStats
            :loading="loading"
            :counter="counter"
            :totals="totals"
            :sms="resource.sms"
            :time="resource.time"
            :tests="resource.tests"
          />
        </v-col>
        <v-col cols="12" RECORD v-if="user.hq || user.manager">
          <v-card class="px-3" :loading="loading">
            <v-row class="pa-0">
              <v-col cols="6">
                <v-btn block text color="success" :loading="loading"  @click="()=>{newDialog = true; interview = true}"
                  :class="`${arabic?'arFont':'enFont'}`"
                >record interviewed</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn block text color="success" :loading="loading"  @click="()=>{newDialog = true; accepted = true}"
                  :class="`${arabic?'arFont':'enFont'}`"
                >record accepted</v-btn>
              </v-col>
            </v-row>
            <v-row row justify-center>
              <v-dialog v-model="newDialog" persistent max-width="1000">
                <v-card :loading="loading">
                  <v-card-title class="headline">{{ interview ? 'Record Interviewed' : 'Record Accepted'}}</v-card-title>
                  <v-card-text v-if="!match_result">
                    <v-row>
                      <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                        <v-autocomplete
                          :items="countries"
                          v-model="selectedCountry"
                          :label="i18n.country"
                          autocomplete="disabled"
                          outlined
                          hide-details
                          dense
                          :loading="loading"
                          clearable
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{i18n[item.slug]}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                        <v-autocomplete
                          :items="programs"
                          v-model="selectedProgram"
                          :label="i18n.program"
                          autocomplete="disabled"
                          outlined
                          :loading="loading"
                          hide-details
                          clearable
                          dense
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{i18n[item.slug]}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                        <v-menu
                          v-model="menu6"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="toDate"
                              label="Interview Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              :loading="loading"
                              outlined
                              hide-details
                              dense
                              clearable
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="toDate"
                            @input="menu6 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-1`">
                        <v-textarea
                          label="Data"
                          outlined
                          clearable
                          :loading="loading"
                          rows="10"
                          clearable-icon="close"
                          dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          v-model="data"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  
                  <v-card-text v-if="match_result">
                    <v-row class="pa-0 align-center mb-1">
                      <listPanel
                        :resource="matchResults"
                        :match="true"
                        :resourceSettings="resourceSettings"
                        @copyS="clipboardSuccessHandler"
                        @copyF="clipboardErrorHandler"
                        :loading="loading"
                        :resourceKeys="resourceKeys"
                      />
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native="()=>{
                      newDialog = false; accepted = false; match_result = false; interview = false
                    }" :loading="loading"
                      >cancel
                    </v-btn>
                    <v-btn color="success" :disabled="!selectedCountry || !selectedProgram || !toDate || !data" v-if="!match_result" :loading="loading" text @click.native="searchBulk()">match</v-btn>
                    <v-btn color="success" v-if="match_result" :loading="loading" text @click.native="createAndRecord()">create and record</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" FILTERS>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="countries"
                    v-model="selectedCountry"
                    :label="i18n.country"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    dense
                    clearable
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{i18n[item.slug]}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="programs"
                    v-model="selectedProgram"
                    :label="i18n.program"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    clearable
                    dense
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{i18n[item.slug]}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="statuses"
                    v-model="selectedStatus"
                    :label="i18n.status"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    clearable
                    dense
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{i18n[item.slug]}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="usersall"
                    v-model="selectedUser"
                    :label="i18n.employee"
                    autocomplete="disabled"
                    outlined
                    :filter="filterObject"
                    hide-details
                    clearable
                    dense
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{item.name}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{item.name}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fromDate"
                        label="From Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        outlined
                        hide-details
                        dense
                        @change="filterLeads()"
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fromDate"
                      @change="filterLeads()"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="toDate"
                        label="To Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        hide-details
                        outlined
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="toDate"
                      @change="filterLeads()"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fromUpdateDate"
                        label="From Update Date"
                        prepend-icon="update"
                        readonly
                        outlined
                        hide-details
                        dense
                        @change="filterLeads()"
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fromUpdateDate"
                      @change="filterLeads()"
                      @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu4"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="toUpdateDate"
                        label="To Update Date"
                        prepend-icon="update"
                        readonly
                        hide-details
                        outlined
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="toUpdateDate"
                      @change="filterLeads()"
                      @input="menu4 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu5"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="interviewDate"
                        label="Interview Date"
                        prepend-icon="event_available"
                        readonly
                        hide-details
                        outlined
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="interviewDate"
                      @change="filterLeads()"
                      @input="menu5 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu7"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="interviewedDate"
                        label="Interviewed Date"
                        prepend-icon="event_available"
                        readonly
                        hide-details
                        outlined
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="interviewedDate"
                      @change="filterLeads()"
                      @input="menu7 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu8"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="acceptedDate"
                        label="Accepted Date"
                        prepend-icon="event_available"
                        readonly
                        hide-details
                        outlined
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="acceptedDate"
                      @change="filterLeads()"
                      @input="menu8 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="['Manual', 'FB Lead', 'Telephone', 'Landing Page', 'Instagram Lead', 'Tiktok Lead']"
                    v-model="selectedSource"
                    :label="i18n.source"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    dense
                    clearable
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{item}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{item}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`" v-if="user && user.role == 'master'">
                  <v-switch label="only AD" v-model="isNew" hide-details @change="filterLeads()"></v-switch>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-switch label="Auto Confirmed" v-model="isAutoconfirmed" hide-details @change="filterLeads()"></v-switch>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 align-center mb-1">
                <listPanel
                  :resource="resource"
                  :resourceSettings="resourceSettings"
                  @editLead="editLead"
                  @copyS="clipboardSuccessHandler"
                  @copyF="clipboardErrorHandler"
                  :loading="loading"
                  :resourceKeys="resourceKeys"
                />
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <multiDialog
          :dialog="dialog"
          :loading="loading"
          :resourceSettings="resourceSettings"
          :deleting="deleting"
          :resourceKeys="resourceKeys"
          :newResource="newResource"
          :show_notes="true"
          @closeDialog="()=>{dialog = false;newResource={};}"
          @deleteResource="deleteResource"
          @updateResource="updateResource"
          @postResource="postResource"
          @newNote="newNote"
          @removeNote="removeNote"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import listPanel from '@/components/listPanel'
import leadsStats from '@/components/leadsStats'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging, multiDialog, listPanel, leadsStats },
  data() {
    return {
      loading:false,
      dialog:false,
      accepted:false,
      interview:false,
      newDialog:false,
      data:null,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys: [{
              name: 'name',
              label: 'name',
              type: 'text',
              fetched: 'name',
              required: true
          },
          {
              name: 'program_id',
              label: 'program',
              type: 'select',
              items: 'programs',
              fetched: 'program_name',
              data: [],
              source: 'db',
              required: true,
              readonly: false
          },
          {
              name: 'country_id',
              label: 'country',
              type: 'select',
              items: 'countries',
              fetched: 'country_name',
              data: [],
              source: 'db',
              required: true,
              readonly: false
          },
          {
              name: 'email',
              label: 'email',
              type: 'text',
              fetched:'email',
              required: true,
              readonly: true
          },
          {
              name: 'phone',
              label: 'phone',
              type: 'text',
              fetched: 'phone',
              required: true,
              readonly: true
          },
          {
              name: 'source',
              label: 'source',
              type: 'text',
              fetched: 'source',
              required: true,
              readonly: true
          },
          {
              name: 'user_id',
              label: 'agent',
              type: 'select',
              items: 'usersall',
              fetched: 'user_name',
              data: [],
              source: 'db',
              required: true,
              readonly: true
          },
          {
              name: 'status_id',
              label: 'status',
              type: 'select',
              items: 'statuses',
              fetched: 'status_name',
              data: [],
              source: 'db',
              required: true
          },
          {
              name: 'interview_id',
              label: 'interview',
              type: 'select',
              items: 'interviewsall',
              fetched: 'interview_name',
              data: [],
              source: 'db',
              required: true
          },
          {
              name: 'appointment',
              label: 'appointment',
              type: 'date',
              fetched: 'appointment',
              required_conditional: true,
              required_condition_field: 'status_id',
              required_condition_value: 2,
              future_date:true,
          },
          {
              name: 'time',
              label: 'time',
              type: 'text',
              fetched: 'time',
              required_conditional: true,
              required_condition_field: 'status_id',
              required_condition_value: 2,
          },
          {
              name: 'note',
              label: 'note',
              type: 'textarea',
              fetched: 'note',
          },
          {
              name: 'call_back_date',
              label: 'call_back_date',
              type: 'date',
              fetched: 'call_back_date',
              required_conditional: true,
              required_condition_field: 'status_id',
              required_condition_value: 3,
              future_date:true,
          },
          {
              name: 'alternative_phone',
              label: 'alternative_phone',
              type: 'text',
              fetched: 'alternative_phone',
          },
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        create:true,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      programs:[],
      countries:[],
      statuses:[],
      usersall:[],
      interviewsall:[],
      selectedUser:null,
      selectedCountry:null,
      selectedProgram:null,
      selectedStatus:null,
      selectedSource:null,
      menu1:false,
      menu2:false,
      menu3:false,
      menu4:false,
      menu5:false,
      menu6:false,
      menu7:false,
      menu8:false,
      fromDate:null,
      toDate:null,
      fromUpdateDate:null,
      toUpdateDate:null,
      interviewDate:null,
      interviewedDate:null,
      acceptedDate:null,
      counter:null,
      totals:{},
      match_result:false,
      matchResults:[],
      page:1,
      isNew:false,
      isAutoconfirmed:false,
    }
  },
  
  methods: {
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async newNote(data) {
        let note = await this.$store.dispatch('postResource', {resource:'/leads-notes', value:{...data}})
        const updateLead = this.resource.data.filter(x=>x.id ===data.new_lead_id)
        if(updateLead.length) {
          updateLead[0].notes.push(note.data)
        }
    },
    async removeNote(data) {
        let note = await this.$store.dispatch('deleteResource', {resource:'/leads-notes/' + data.id})
        const updateLead = this.resource.data.filter(x=>x.id ===data.new_lead_id)
        if(updateLead.length) {
          updateLead[0].notes.splice(updateLead[0].notes.findIndex(x=>x.id ===data.id), 1)
        }
    },
    async createAndRecord(){
      this.loading = true
      console.log(this.matchResults.data)
      let p = {
        leads:this.matchResults.data,
        date:this.toDate,
        program: this.selectedProgram,
        status: this.interview ? 'interview' : this.accepted ? 'accepted' : null
      }
      console.log(p)
      let s = await axios.post(`${this.api}/leads/create-record`, p, {headers}).then(x=>x.data)
      console.log(s)
      this.accepted = null
      this.interview = null
      this.selectedCountry = null
      this.selectedProgram = null
      this.toDate = null
      this.data = null
      this.newDialog = false
      this.loading = false
      this.match_result = false
      this.matchResults = []
      this.loadResource()
    },
    async searchBulk(){
      this.loading = true
      console.log(this.accepted)
      console.log(this.interview)
      console.log(this.selectedCountry)
      console.log(this.selectedProgram)
      console.log(this.toDate)
      console.log(this.data)
      if(!this.data.includes('\n') || !this.data.includes('\t')) {
        this.$emit('snackbarNotification', `Please check data`, 'error')
        this.loading = false
        return true
      }
      let splits = this.data.split('\n').map(x=>x.split("\t").map(y=>y.trim()))
      console.log(splits)
      if(!splits.length) {
        this.$emit('snackbarNotification', `Please check data`, 'error')
        this.loading = false
        return true
      }
      let data = []
      splits.forEach(l=>{
        let lead = {
          name:l[0] != '' ? l[0] : null,
          email:l[1] != '' ? l[1] : null,
          phone:l[2] != '' ? l[2] : null,
        }
        data.push(lead)
      })
      if(!data.length) {
        this.$emit('snackbarNotification', `Please check data`, 'error')
        this.loading = false
        return true
      }
      let p = {
        items:data,
        date:this.toDate,
        program:this.selectedProgram,
        country:this.selectedCountry,
      }
      console.log(p)
      let s = await axios.post(`${this.api}/leads/bulk-search`, p, {headers}).then(x=>x.data)
      this.matchResults = s
      this.match_result = true
      this.loading = false
      this.$emit('snackbarNotification', `Matched | ${s.data.filter(x=>!x.id).length} not in system` , 'success')
      console.log(s)
    },
    editLead(r){
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = this.resource[f]
            if(!t.error) {
              let maps = t.map(x=>{
                let t = x.name?x.name:x.company?x.company:x.country?x.country:x.program?x.program:null
                console.log(t)
                return{...x, text:t, [`${f.items}_id`]:x.id}
              })
              f.data = maps
            }
          }
          res(true)
        })()
      })
    },
    getItems(items) {
      return this.resourceKeys.filter(x=>x.items == items)[0].data
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.required}`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.valid_email}`, 'error')
        }
      })
      return v
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadSettingsItems(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let ks = ['countries', 'programs', 'statuses', 'usersall', 'interviewsall'];
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = this.resource[f]
            console.log('items', f, t)
            if(!t.error)
            t.forEach(x=> this.$store.state.i18n.en[x.slug] = x.en)
            t.forEach(x=> this.$store.state.i18n.ar[x.slug] = x.ar)
            t.forEach(x=> this.$store.state.i18n.fr[x.slug] = x.fr)
            this[f] = t
          }
          let rks = this.resourceKeys.filter(x=>x.type == 'select' && x.source == 'db')
          for (let i = 0; i < rks.length; i++) {
            const rk = rks[i];
            rk.data = this[rk.items].map(x=>{
              let text = x.slug ? this.i18n[x.slug] : x.name
              return{...x, [rk.name + '_id']: x.id, text}
            })
            console.log(rk.data)
          }
          this.loading = false
          res(true)
        })()
      })
    },
    buildFilter(){
      let filter = ``
      if(this.selectedCountry) {
        filter += `&country_id=${this.selectedCountry}`
      }
      if(this.selectedProgram) {
        filter += `&program_id=${this.selectedProgram}`
      }
      if(this.selectedStatus) {
        filter += `&status_id=${this.selectedStatus}`
      }
      if(!this.fromDate) this.fromDate = new Date( new Date().getTime() - 24*60*60*1000 ).toISOString().split('T')[0]
      if(!this.toDate) this.toDate = new Date().toISOString().split('T')[0]
      if(this.fromDate && this.toDate) {
        filter += `&from_date=${this.fromDate}&to_date=${this.toDate}`
      }
      if(this.fromUpdateDate && this.toUpdateDate) {
        filter += `&from_update_date=${this.fromUpdateDate}&to_update_date=${this.toUpdateDate}`
      }
      if(this.interviewDate) {
        filter += `&interview_date=${this.interviewDate}`
      }
      if(this.interviewedDate) {
        filter += `&confirmed_date=${this.interviewedDate}`
      }
      if(this.acceptedDate) {
        filter += `&accepted_date=${this.acceptedDate}`
      }
      if(this.selectedUser) {
        filter += `&user_id=${this.selectedUser}`
      }
      if(this.selectedSource) {
        filter += `&source=${this.selectedSource}`
      }
      if(this.isNew) {
        filter += `&only_advert=${this.isNew?'filter':''}`
      }
      if(this.isAutoconfirmed) {
        filter += `&only_autocon=${this.isAutoconfirmed?'filter':''}`
      }
      
      return filter
    },
    async filterLeads(){
      await this.loadResource()
    },
    firstLoad(){
      if(this.user && !this.user.hq) {
        console.log(this.user)
        this.selectedCountry = this.user.countries[0].id
      }
    },
    async Counter(counter){
      return new Promise(async (res, rej)=>{
        // let counter = await this.$store.dispatch('getResource', {resource:this.$route.path + '-counter' + '?' + this.buildFilter()})
        console.log('counter', counter, this.resource.counters)
        let c = this.countries.map(x=>x.id)
        let c_grouped = []
        let c_n = counter.map(x=>{
          return {
            ...x,
            country_name:this.countries.filter(y=>y.id == x.country)[0],
            program_name:this.programs.filter(y=>y.id == x.program)[0],
            status_name:this.statuses.filter(y=>y.id == x.status)[0],
          }
        })
        console.log('this.counter c', c)
        console.log('this.counter c_n', c_n)
        c.forEach(id => {
          c_grouped.push([...c_n.filter(x=>x.country == id)])
        });
        console.log('this.counter c_grouped', c_grouped)
        console.log('this.counter c_grouped.filter(x=>x.length)', c_grouped.filter(x=>x.length))
        this.counter = c_grouped.filter(x=>x.length).map(x=>x.sort((a, b)=> a.program - b.program))
        this.totals = {
          total: counter.reduce((total, a)=> total + a.total_count , 0)
        }
        console.log('this.totals', this.totals)
        console.log('this.counter', this.counter)
        res()
      })
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(this.search)
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${this.page}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
        let ks = ['countries', 'programs', 'statuses', 'usersall', 'interviewsall'];
        ks.forEach(k=> this[k]=this.resource[k])
        await this.Counter(this.resource.counters)
        res()
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        this.page = n
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise((res, rej)=>{
        this.loading = true
        this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        .then(async (data) => {
          this.dialog = false
          this.editing = false
          this.loading = false
          await this.loadResource()
          this.newResource = {}
          res(data)
        })
        .catch((err) => {
          this.loading = false
          this.$emit('snackbarNotification', 'An error has occured !', 'error')
          rej(err)
        })
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async postResource(r){
      return new Promise((res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        .then(async (data) => {
          this.dialog = false
          this.loading = false
          await this.loadResource()
          res(data)
          this.newResource = {}
        })
        .catch((err) => {
          this.loading = false
          this.$emit('snackbarNotification', 'An error has occured !', 'error')
          rej(err)
        })
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    },
  },
  watch: {
    '$store.state.online'(value) {
      this.loading = !Boolean(value)
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    this.firstLoad()
    await this.loadResource()
    this.loadSettingsItems()
    // await this.loadItems()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>